// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__T5pzM"};